// src/pages/Donate.tsx
import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  Card,
  CardHeader,
  CardBody,
  VStack,
  Icon,
  Button,
} from "@chakra-ui/react";
import { PhoneIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";

const donateOptions = [
  {
    providerKey: "mtn",
    number: "6 72 92 71 77",
    color: "yellow.400",
  },
  {
    providerKey: "orange",
    number: "672 927 177",
    color: "orange.400",
  },
];

export default function Donate() {
  const { t } = useTranslation();

  return (
    <Box py={12} px={{ base: 4, md: 12 }} textAlign="center">
      <Heading as="h1" size="xl" mb={4} color="blue.600">
        {t("donate.title")}
      </Heading>
      <Text fontSize="lg" maxW="2xl" mx="auto" mb={10} color="gray.600">
        {t("donate.description")}
      </Text>

      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        spacing={8}
        justifyItems="center"
      >
        {donateOptions.map((option) => (
          <Card
            key={option.providerKey}
            w="full"
            maxW="sm"
            boxShadow="md"
            borderTop="4px solid"
            borderColor={option.color}
            _hover={{
              transform: "translateY(-5px)",
              transition: "0.2s ease-in-out",
            }}
          >
            <CardHeader>
              <Heading as="h3" size="md" color="blue.700">
                {t(`donate.providers.${option.providerKey}`)}
              </Heading>
            </CardHeader>
            <CardBody>
              <VStack spacing={4}>
                <Icon as={PhoneIcon} boxSize={6} color={option.color} />
                <Text fontSize="2xl" fontWeight="bold" color="gray.800">
                  {option.number}
                </Text>
                <Button
                  colorScheme="blue"
                  variant="outline"
                  size="sm"
                  onClick={() => navigator.clipboard.writeText(option.number)}
                >
                  {t("donate.copyNumber")}
                </Button>
              </VStack>
            </CardBody>
          </Card>
        ))}
      </SimpleGrid>

      <Box mt={16}>
        <Text fontSize="sm" color="gray.500">
          {t("donate.verse")}
        </Text>
      </Box>
    </Box>
  );
}
